"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalAdAccountResponseToJSON = exports.InternalAdAccountResponseFromJSONTyped = exports.InternalAdAccountResponseFromJSON = exports.instanceOfInternalAdAccountResponse = void 0;
var runtime_1 = require("../runtime");
var AdAccountSource_1 = require("./AdAccountSource");
var AdAccountTaxResponseObject_1 = require("./AdAccountTaxResponseObject");
/**
 * Check if a given object implements the InternalAdAccountResponse interface.
 */
function instanceOfInternalAdAccountResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfInternalAdAccountResponse = instanceOfInternalAdAccountResponse;
function InternalAdAccountResponseFromJSON(json) {
    return InternalAdAccountResponseFromJSONTyped(json, false);
}
exports.InternalAdAccountResponseFromJSON = InternalAdAccountResponseFromJSON;
function InternalAdAccountResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'emailSubscribed': !(0, runtime_1.exists)(json, 'email_subscribed') ? undefined : json['email_subscribed'],
        'email': !(0, runtime_1.exists)(json, 'email') ? undefined : json['email'],
        'invoiceEnabled': !(0, runtime_1.exists)(json, 'invoice_enabled') ? undefined : json['invoice_enabled'],
        'leadContactName': !(0, runtime_1.exists)(json, 'lead_contact_name') ? undefined : json['lead_contact_name'],
        'leadId': !(0, runtime_1.exists)(json, 'lead_id') ? undefined : json['lead_id'],
        'source': !(0, runtime_1.exists)(json, 'source') ? undefined : (0, AdAccountSource_1.AdAccountSourceFromJSON)(json['source']),
        'taxIds': !(0, runtime_1.exists)(json, 'tax_ids') ? undefined : (json['tax_ids'].map(AdAccountTaxResponseObject_1.AdAccountTaxResponseObjectFromJSON)),
        'currencyCode': !(0, runtime_1.exists)(json, 'currency_code') ? undefined : json['currency_code'],
    };
}
exports.InternalAdAccountResponseFromJSONTyped = InternalAdAccountResponseFromJSONTyped;
function InternalAdAccountResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'email_subscribed': value.emailSubscribed,
        'email': value.email,
        'invoice_enabled': value.invoiceEnabled,
        'lead_contact_name': value.leadContactName,
        'lead_id': value.leadId,
        'source': (0, AdAccountSource_1.AdAccountSourceToJSON)(value.source),
        'tax_ids': value.taxIds === undefined ? undefined : (value.taxIds.map(AdAccountTaxResponseObject_1.AdAccountTaxResponseObjectToJSON)),
        'currency_code': value.currencyCode,
    };
}
exports.InternalAdAccountResponseToJSON = InternalAdAccountResponseToJSON;
